module.exports = __webpack_public_path__ + "img/elementlengths_jas.860f5994.png";